import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../core/models/app.settings';
import { Settings } from '../../../core/models/app.settings.model';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
})
export class ErrorComponent {
  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router) {
    this.settings = this.appSettings.settings;
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.settings.loadingSpinner = false;
    });
  }
}
